import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size?: IconSize;
}

const ArrowLeft = (props: IconProps) => (
  <SvgIcon size={props.size}>
    <path
      d="M8.51 19.021L1.5 12.01 8.51 5M2 12h22"
      stroke="currentColor"
      strokeWidth="2"
    />
  </SvgIcon>
);

export default ArrowLeft;
